import { render, staticRenderFns } from "./PermissionAssignmentUser.vue?vue&type=template&id=383a8352&scoped=true&"
import script from "./PermissionAssignmentUser.vue?vue&type=script&lang=js&"
export * from "./PermissionAssignmentUser.vue?vue&type=script&lang=js&"
import style0 from "./PermissionAssignmentUser.vue?vue&type=style&index=0&id=383a8352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a8352",
  null
  
)

export default component.exports